'use strict';

const Nag = require('../../../modules/ui/nag/nag');
const shoppingCart = require('od-modules/cart/cart');
const isProductFiltered = require('../ancillaries_module.collection.product.filtering');
const {additionalProductsCatalog} = require('od-modules/track_events/track.frontevents.additional.products');

const NAG_CLASS = 'ancillariesNag';
const REJECTED_POLICY = 'none';
const CACHE_ID_SEPARATOR = '#';
const DEFAULT_TEMPLATE = 'default';
let hasMandatorySelectionErrorBeenShown = false;
const CART_REFRESH_ACTIONS = ['ADD', 'REMOVE'];
const NAG_LABEL = {
    reject: 'INSURANCE_REJECT',
    continuance: 'ANCILLARIES_STEP',
};

const isContinuanceNagEnabled = (offer) => Odigeo._.get(offer, 'flags.continuanceNagEnabled', false);

const isMandatorySelectionEnabled = (offer) => Odigeo._.get(offer, 'flags.mandatorySelection', false);

const isPendingFromDecision = (offer) => Odigeo._.get(offer, 'pendingDecision', false);

const isRejectNagEnabled = (offer) => Odigeo._.get(offer, 'flags.rejectNagEnabled', false);

const isMandatory = (offer) => Odigeo._.get(offer, 'flags.mandatory', false);

const isModalEnabled = (offer) => Odigeo._.get(offer, 'flags.modal', false);

const isConfirmationNagEnabled = (offer) => Odigeo._.get(offer, 'flags.confirmable', false);

const getShoppingCartItems = (policies = []) => shoppingCart.take.insurances(({name}) => policies.includes(name));

const getShoppingCartId = (policy, id) => shoppingCart.builders.insurance.id(policy, id).name;

const automaticallyAddedPolicies = () => shoppingCart
    .getItems(({source}) => source.action === shoppingCart.sources.actions.AUTOMATICALLY_ADDED)
    .map(({type}) => type);

const isShoppingCartFreeOfInsurances = () => shoppingCart.take.realInsurances().length === 0;

/**
 * @class AncillariesModuleModelBase
 * @extends Odigeo.Model
 */
module.exports = Odigeo.Model.extend({
    silentChange: false,
    selectionCacheID: null,
    sortHubsBy: 0,
    lastPolicyInteractedWith: REJECTED_POLICY,
    connect: true,
    selectors: ['primeMemberSelected', 'membershipSubscriptionDetails'],
    cartSubscriptionEnabled: true,
    cartSubscribed: false,

    initialize() {
        if (this.cartSubscriptionEnabled && !this.cartSubscribed) {
            shoppingCart.subscribe(this.refreshFromShoppingCart.bind(this));
            this.cartSubscribed = true;
        }
    },

    getFormattedData(data) {
        const formattedData = Odigeo._.isObject(data) ? data : {};
        formattedData.isMultiOffer = Odigeo._.isArray(this.getDataProducts(data));
        return formattedData;
    },

    getDataProducts(data) {
        return Odigeo._.get(data, 'products');
    },

    parseMultiOfferData(data) {
        Odigeo._.each(this.getDataProducts(data), this.parseProductData, this);
    },

    parseSingleOfferData(formattedData) {
        this.parseProductData(formattedData);
    },

    parse(data) {
        this.resetSelectionCacheID();

        const formattedData = this.getFormattedData(data);

        formattedData.isMultiOffer ? this.parseMultiOfferData(data) : this.parseSingleOfferData(formattedData);

        this.orderHubs(formattedData);

        return formattedData;
    },

    orderHubs(data) {
        if (Odigeo._.get(data, 'isMultiOffer')) {
            data.products = Odigeo._.sortBy(data.products, function(product) {
                return Odigeo._.get(product, 'offerTemplate') === 'insurancesItemHub' ? this.sortHubsBy : 0;
            }, this);
        }
    },

    getNagContinueGroup() {
        return Odigeo._.get(this.getOffersList(), '[0].continueNagGroup');
    },

    parseProductData(offer) {
        this.parsePriceToDisplay(offer);
        this.parseUrlConditions(offer);
        this.parseSelectionCacheID(offer);
    },

    formatPrices(data) {
        return Odigeo._.isObject(data.prices) ? data.prices : {priceToDisplay: 0};
    },

    getRawPrice(data, property) {
        return Odigeo._.get(data, ['prices', property || 'priceToDisplay'], 0);
    },

    parsePriceToDisplay(data) {
        data.prices = this.formatPrices(data);
        Odigeo._.forEach(data.prices, (value, key) => {
            const formattedKey = `${key}Formatted`;
            data.prices[formattedKey] = Odigeo.Utils.formatCurrency(this.getRawPrice(data, key));
        });
    },

    parseUrlConditions(data) {
        const urlConditionsParsedProp = !Odigeo._.isEmpty(data.urlExtended) ? 'urlExtended' : 'url';
        data.urlConditionsParsed = Odigeo._.get(data, urlConditionsParsedProp, '');
    },

    resetSelectionCacheID() {
        this.selectionCacheID = CACHE_ID_SEPARATOR;
    },

    parseSelectionCacheID(data) {
        this.selectionCacheID += Odigeo._.get(data, 'policy') || '__NO_POLICY_FOUND__';
        this.selectionCacheID += CACHE_ID_SEPARATOR;
    },

    isInPreRejectedState() {
        return this.get('rejectAll') && this.isProductNoSelected();
    },

    getSelectedPolicyOrPrecheckedOffer() {
        return this.thereIsAnyOfferInSelectionCache()
            ? this.getSelectedPolicy()
            : Odigeo._.get(this.getPrecheckedOffer(), 'policy');
    },

    getPrecheckedPolicy() {
        return this.isInPreRejectedState()
            ? REJECTED_POLICY
            : this.getSelectedPolicyOrPrecheckedOffer();
    },

    isPrecheckedPolicy() {
        return this.getPrecheckedPolicy() !== REJECTED_POLICY && !Odigeo._.isUndefined(this.getPrecheckedPolicy());
    },


    shouldBeSelected(precheckedPolicy) {
        return precheckedPolicy !== REJECTED_POLICY
            && !Odigeo._.isEmpty(precheckedPolicy) !== this.isSelected(precheckedPolicy);
    },

    shouldUpdateSelection(precheckedPolicy) {
        return this.thereIsAnyOfferInSelectionCache() || this.shouldBeSelected(precheckedPolicy);
    },

    isPolicySelected(precheckedPolicy) {
        return !this.isInPreRejectedState() && !Odigeo._.isEmpty(precheckedPolicy);
    },

    afterSync() {
        this.addPrecheckedPolicyToShoppingCart();
        this.loadProductsFromShoppingCart();
    },

    addPrecheckedPolicyToShoppingCart() {
        const precheckedPolicy = this.getPrecheckedPolicy();
        const precheckedCartId = getShoppingCartId(precheckedPolicy, this.getProductId(precheckedPolicy));

        if (this.isPrecheckedPolicy()
            && !shoppingCart.containsProduct(precheckedCartId)
            && !shoppingCart.hasProductBeenRemoved(precheckedCartId)) {
            this.updateProductInShoppingCart({
                policy: precheckedPolicy,
                selected: true,
                source: shoppingCart.sources.actions.PRESELECTED,
            });
        }
    },

    loadProductsFromShoppingCart() {
        getShoppingCartItems(this.getShoppingCartIds(this.getPolicyList()))
            .forEach((item) => {
                if (this.shouldBeLoadedFromShoppingCart(item.type)) {
                    this.selectProduct({selected: true, policy: item.type, silent: false, updateCart: false});
                }
            });
    },

    refreshFromShoppingCart({action, data = {}} = {}) {
        const {type} = data;

        if (this.shouldRefreshFromShoppingCart({action, data})) {
            this.selectProduct({selected: action === 'ADD', policy: type, silent: false, updateCart: false});
        }
    },

    shouldRefreshFromShoppingCart({action, data = {}} = {}) {
        const {type, source = {}} = data;
        const {target} = source;

        return target !== shoppingCart.sources.targets.WIDGET
            && this.getPolicyList().includes(type)
            && CART_REFRESH_ACTIONS.includes(action)
            && this.isPolicyDisplayable(type);
    },

    shouldBeLoadedFromShoppingCart(policy) {
        return !this.isSelected(policy) && this.isPolicyDisplayable(policy);
    },

    isPolicyDisplayable(policy) {
        return this.isDisplayable(this.getOfferByPolicy(policy));
    },

    getShoppingCartIds(policies = []) {
        return policies.map((policy) => shoppingCart.builders.insurance.id(policy, this.getProductId(policy)).name);
    },

    getPolicyList() {
        const list = this.getOffersList() || [];
        return list.map(({policy}) => policy);
    },

    getNagContent(offer, nagType) {
        return Odigeo._.extend(this.getNagTexts(offer, nagType), this.getPrices(offer));
    },

    getPrices(offer) {
        if (Odigeo.AB.getSmartRejectionNag > 1 ) {
            return Odigeo._.pick(offer.prices, ['priceToDisplayFormatted', 'text']);
        }
        return Odigeo._.pick(offer.prices, 'priceToDisplayFormatted');
    },

    getNagTexts(offer, nagType) {
        switch (nagType) {
            case Nag.NAG_TYPE.reject:
            case Nag.NAG_TYPE.continuance:
                return offer.texts.continuanceNag;
            case Nag.NAG_TYPE.confirmation:
                return offer.texts.confirmationNag;
            default:
                return {};
        }
    },

    isNagAvailable() {
        return this.isRemoveNagAvailable()
            || this.isConfirmationNagAvailable()
            || this.hasToDisplayContinueNag();
    },

    shouldCreateNag() {
        return Odigeo._.isUndefined(this.nag) && this.isNagAvailable();
    },

    createNag({offer, nagType}) {
        const nagLabel = NAG_LABEL[nagType];
        this.nag = new Nag({
            template: this.collection.widget.view.getStaticTemplateBuilder('nag', DEFAULT_TEMPLATE),
            instanceID: this.selectionCacheID,
            nagClass: NAG_CLASS,
            doNotShowIfSameNagClassAlreadyShown: false,
            translations: this.getNagContent(offer, nagType),
            transitions: this.getNagTransitions(),
            label: additionalProductsCatalog.NAGS.label(`${nagLabel}:APPEARANCE`),
            actionLabel: additionalProductsCatalog.NAGS.label(`${nagLabel}:ACCEPTANCE`),
            ignoreLabel: additionalProductsCatalog.NAGS.label(`${nagLabel}:REJECTION`),
            className: `${nagType}_class`,
            offer: offer,
        });
    },

    getHandlerName(nagType, handler) {
        return Odigeo._.camelCase(`${DEFAULT_TEMPLATE} ${handler}`);
    },

    bindNag(nagType) {
        if (Odigeo.AB.getSmartRejectionNag > 1) {
            this.nag.on(Nag.NAG_LOCAL_EVENTS.onAcceptNag, this.onSmartNagContinue.bind(this, this.nag.offer.policy));
            this.nag.on(Nag.NAG_LOCAL_EVENTS.onRejectNag, this.onSmartNagReject(nagType));
        } else {
            this.nag.on(Nag.NAG_LOCAL_EVENTS.onAcceptNag, this.getNagAcceptedTrigger(nagType));
            this.nag.on(Nag.NAG_LOCAL_EVENTS.onRejectNag, this.getNagRejectedTrigger(nagType));
        }
    },

    onSmartNagReject(nagType) {
        $('.ancillaries_step_button')[0].click();
        return this.getNagRejectedTrigger(nagType);
    },

    onSmartNagContinue(policy) {
        this.selectProduct({selected: true, policy, silent: false, updateCart: true});
        $('.ancillaries_step_button')[0].click();
    },

    getNagAcceptedTrigger(nagType) {
        return Odigeo._.bind(this.trigger, this, this.getHandlerName(nagType, 'nagAccepted'));
    },

    getNagRejectedTrigger(nagType) {
        return Odigeo._.bind(this.trigger, this, this.getHandlerName(nagType, 'nagRejected'));
    },

    initNagIfNeeded(offer, nagType) {
        if (this.shouldCreateNag()) {
            this.createNag({offer, nagType});
            this.bindNag(nagType);
        }
    },

    getNagTransitions() {
        return {
            accept: (nag, done) => {
                if (Odigeo.AB.getSmartRejectionNag > 1) {
                    $('#nag_container .nag_box #nag_body').addClass('odf-hidden');
                    $('#nag_container .nag_box #nag_success').toggleClass('odf-hidden');
                    const timer = setTimeout(() => {
                        done(nag);
                        clearTimeout(timer);
                    }, 3000);
                } else {
                    done(nag);
                }
            },
            reject: Nag.defaultTransition,
        };
    },

    getTrackingPolicy(policy) {
        return !Odigeo._.isEmpty(policy) || this.isMultiOffer() ? policy : this.getPolicyFromSimpleOffer();
    },

    getAddAction(selected, policy) {
        return this.isRejected(policy) || selected;
    },

    shouldTrackProducToggled(trackingPolicy) {
        return !Odigeo._.isEmpty(this.getOfferByPolicy(trackingPolicy)) || this.isRejected(trackingPolicy);
    },

    trackProductToggled(selected, policy) {
        const trackingPolicy = this.getTrackingPolicy(policy);
        // TODO: this is a dirty hack have to do for copying the behaviour of insurancemanager.
        // We should get rid of this hack when unification is rolled out and we don't use old insurances template anymore
        if (this.shouldTrackProducToggled(trackingPolicy)) {
            this.collection.widget.tracking.addOrRemoveProduct(trackingPolicy, this.getAddAction(selected, policy));
        }
    },

    getNotifyPolicy(policy) {
        return this.isRejected(policy) ? this.getAddedPolicy() : policy;
    },

    selectProduct({selected = false, policy, silent = false, updateCart = true}) {
        this._selectProduct({selected, newPolicy: policy, oldPolicy: this.getAddedPolicy(), updateCart});

        if (!silent) {
            this.notifySelectionChange(selected, this.getNotifyPolicy(policy));
        }

        this.refreshFullPriceAutoCheckInPaxDesktop();
    },

    _selectProduct({selected = false, newPolicy, updateCart = true}) {
        this.setIfSelected(selected, newPolicy);

        if (updateCart) {
            this.updateProductInShoppingCartWhenEnabled(selected, newPolicy);
        }
    },

    refreshFullPriceAutoCheckInPaxDesktop() {
        const actualPage = Odigeo.History.getPageNameFromFragment();
        if (Odigeo.AB.isAutomaticCheckinPaxDesktop && actualPage === 'details') {
            Odigeo.trigger('getTotalByFullprice');
        }
    },

    updateProductInShoppingCartWhenEnabled(selected, newPolicy) {
        this.updateProductInShoppingCart({
            policy: newPolicy,
            selected,
        });
    },

    updateProductInShoppingCart({policy, selected, source = shoppingCart.sources.actions.USER_REQUESTED}) {
        const {texts = {}, prices = {}, priceBreakDown = {}} = this.getOfferByPolicy(policy) || {};
        const {totalPrice = 0} = prices;
        const {type = ''} = priceBreakDown;

        shoppingCart.builders.insurance.id(policy, this.getProductId(policy)).data({
            id: this.getProductId(policy),
            type: policy,
            concept: texts.productTitle,
            price: {
                total: totalPrice,
            },
            extra: {
                insuranceType: type,
            },
        }).from(source, shoppingCart.sources.targets.WIDGET).toggle(selected);

        this.detachOtherMultiOfferProducts(policy);
    },

    detachOtherMultiOfferProducts(newPolicy) {
        const policiesToAvoid = [...automaticallyAddedPolicies(), newPolicy];

        this.getPolicies()
            .filter((policy) => !policiesToAvoid.includes(policy))
            .forEach((policy) => {
                shoppingCart.builders.insurance
                    .id(policy, this.getProductId(policy))
                    .remove();
            });
    },

    isAddAction(policy) {
        return !this.isSelected(policy)
            && (!this.isMultiOffer() && !this.isRejected(policy) || !Odigeo._.isEmpty(this.getOfferByPolicy(policy)));
    },

    toggleSelected(policy) {
        const isAddAction = this.isAddAction(policy);

        this.trackProductToggled(isAddAction, policy);
        this.checkNagAndSelectProduct(isAddAction, policy);
    },

    checkNagAndSelectProduct(isAddAction, policy) {
        if (this.hasToDisplayRemoveNag(!isAddAction)) {
            this.triggerAncillaryNag(Nag.NAG_TYPE.reject);
        } else if (this.hasToDisplayConfirmationNag(!isAddAction) && !this.collection.isAnyProductSelected()) {
            this.triggerAncillaryNag(Nag.NAG_TYPE.confirmation);
        } else {
            this.selectProduct({selected: isAddAction, policy});
        }

        this.setValidationFailed(false);
    },

    isContinuanceNagFlagEnabled() {
        return Odigeo._.some(this.getFilteredOffersList(), isContinuanceNagEnabled);
    },

    isMandatorySelectionFlagEnabled() {
        return Odigeo._.some(this.getOffersList(), isMandatorySelectionEnabled);
    },

    isPendingDecisionEnabled() {
        return Odigeo._.some(this.getOffersList(), isPendingFromDecision);
    },

    isConfirmationNagFlagEnabled() {
        return Odigeo._.some(this.getOffersList(), isConfirmationNagEnabled);
    },

    hasToDisplayContinueNag() {
        return isShoppingCartFreeOfInsurances() && !this.thereIsAnyOfferInSelectionCache() && this.isContinuanceNagFlagEnabled();
    },

    hasToDisplayMandatorySelectionError() {
        return this.isProductNoSelected()
            && this.isMandatorySelectionFlagEnabled()
            && !Nag.isNagClassAlreadyBeenShown(NAG_CLASS);
    },

    isProductNoSelected() {
        return !this.isSelected() && !this.thereIsAnyOfferInSelectionCache();
    },

    getContinuanceNagOffer() {
        if (Odigeo.AB.getSmartRejectionNag === 2 && !this.isSelected()) {
            return this.firstProductWithContinuanceNagEnabled();
        } else if (Odigeo.AB.getSmartRejectionNag === 3 && !this.isSelected()) {
            return this.lastProductWithContinuanceNagEnabled();
        }
        return !this.isSelected()
            ? Odigeo._.find(this.getOffersList(), isContinuanceNagEnabled)
            : null;
    },

    getRejectNagOffer() {
        const selectedOffer = this.getSelectedOffer();
        let nagOffer;

        if (Odigeo.AB.getSmartRejectionNag === 2) {
            return this.firstProductWithRejectNagEnabled();
        } else if (Odigeo.AB.getSmartRejectionNag === 3) {
            return this.lastProductWithRejectNagEnabled();
        }

        if (Odigeo._.isEmpty(selectedOffer) && this.isMultiOffer()) {
            nagOffer = this.firstProductWithRejectNagEnabled();
        } else if (isRejectNagEnabled(selectedOffer)) {
            nagOffer = selectedOffer;
        }

        return nagOffer;
    },

    getConfirmationNagOffer() {
        return !this.isSelected()
            ? Odigeo._.find(this.getOffersList(), isConfirmationNagEnabled)
            : null;
    },

    hasMandatorySelectionErrorBeenShown() {
        return hasMandatorySelectionErrorBeenShown;
    },

    setMandatorySelectionErrorAsShown() {
        hasMandatorySelectionErrorBeenShown = true;
        this.collection.widget.tracking.mandatorySelectionError(this.getPolicyFromSimpleOffer());
    },

    firstProductWithRejectNagEnabled() {
        return Odigeo._.find(this.getProducts(), isRejectNagEnabled);
    },

    lastProductWithRejectNagEnabled() {
        return Odigeo._.findLast(this.getProducts(), isRejectNagEnabled);
    },

    firstProductWithContinuanceNagEnabled() {
        return Odigeo._.find(this.getProducts(), isContinuanceNagEnabled);
    },

    lastProductWithContinuanceNagEnabled() {
        return Odigeo._.findLast(this.getProducts(), isContinuanceNagEnabled);
    },

    isMultiOfferRejectNagEnabled() {
        return this.isMultiOffer() && !Odigeo._.isEmpty(this.firstProductWithRejectNagEnabled());
    },

    isRemoveNagAvailable() {
        const selectedOffer = this.getSelectedOffer();
        return !Odigeo._.isEmpty(selectedOffer) ? isRejectNagEnabled(selectedOffer) : this.isMultiOfferRejectNagEnabled();
    },

    isConfirmationNagAvailable() {
        const selectedOffer = this.getSelectedOffer();
        return !Odigeo._.isEmpty(selectedOffer) ? isConfirmationNagEnabled(selectedOffer) : false;
    },

    getAddedPolicy() {
        return this.isSelected() ? this.getSelectedPolicy() : null;
    },

    hasToDisplayRemoveNag(isRemoveAction) {
        return !!isRemoveAction
            && !this.isInPreRejectedState()
            && this.isRemoveNagAvailable()
            && !Nag.isNagClassAlreadyBeenShown(NAG_CLASS)
            && !this.hasMandatorySelectionErrorBeenShown();
    },

    hasToDisplayConfirmationNag(isRemoveAction) {
        return !!isRemoveAction
            && !this.isInPreRejectedState()
            && this.isConfirmationNagFlagEnabled()
            && !Nag.isNagClassAlreadyBeenShown(NAG_CLASS)
            && !this.hasMandatorySelectionErrorBeenShown();
    },

    thereIsAnyOfferInSelectionCache() {
        return !Odigeo._.isEmpty(this.collection?.selectionCache[this.selectionCacheID]);
    },

    hasToDisplayContinuanceNag() {
        return this.hasToDisplayContinueNag() && !Nag.isNagClassAlreadyBeenShown(NAG_CLASS);
    },

    mustTriggerAncillaryNag() {
        return this.isRemoveNagAvailable()
            || this.isConfirmationNagFlagEnabled()
            || this.hasToDisplayContinueNag();
    },

    getPageToTrack() {
        return this.collection.widget.tracking.getPageToTrack();
    },

    getTriggerTrackingData({policy}, nagType) {
        return this.collection.widget.tracking.getNagTrackData(policy, nagType);
    },

    launchShowTracking(offer, nagType) {
        this.nag.updateTracking(this.getTriggerTrackingData(offer, nagType), this.getPageToTrack());
    },

    showAncillaryNag(offer, nagType) {
        if (!Odigeo._.isEmpty(offer)) {
            this.initNagIfNeeded(offer, nagType);
            this.launchShowTracking(offer, nagType);

            return this.nag.show(nagType);
        }

        return false;
    },

    triggerAncillaryNag(nagType) {
        return this.mustTriggerAncillaryNag()
            ? this.showAncillaryNag(this.getAncillaryNagOffer(nagType), nagType)
            : false;
    },

    triggerPendingDecisionError() {
        this.trigger('pendingDecisionError');
    },

    getAncillaryNagOffer(nagType) {
        switch (nagType) {
            case Nag.NAG_TYPE.continuance:
                return this.getContinuanceNagOffer();
            case Nag.NAG_TYPE.reject:
                return this.getRejectNagOffer();
            case Nag.NAG_TYPE.confirmation:
                return this.getConfirmationNagOffer();
            default:
                return null;
        }
    },

    getPolicyFromSimpleOffer: function() {
        return this.get('policy');
    },

    getTemplate() {
        return this.get('template');
    },

    getViewClass() {
        return this.isMultiOffer() ? this.getViewClassMultiOffer() : this.getTemplate();
    },

    filterProductsToCheck(products) {
        return Odigeo._.size(products) === 1
            ? products
            : Odigeo._.reject(products, 'offerTemplate', 'insurancesItemHub', 'offerTemplate');
    },

    getViewClassMultiOffer() {
        return Odigeo._.get(Odigeo._.find(this.filterProductsToCheck(this.getProducts())), 'offerTemplate', null);
    },

    getPolicyOrSelected(policy) {
        return !Odigeo._.isUndefined(policy) ? policy : this.getSelectedPolicy();
    },

    isRejected(policy) {
        return this.getPolicyOrSelected(policy) === REJECTED_POLICY;
    },

    isNotRejected(policy) {
        return !Odigeo._.isUndefined(policy) && !this.isRejected(policy);
    },

    getRejectedPolicy() {
        return REJECTED_POLICY;
    },

    isSelected(policy) {
        return !Odigeo._.isUndefined(policy)
            ? policy === this.getSelectedPolicy()
            : this.isNotRejected(this.getSelectedPolicy());
    },

    getSelectedPolicy() {
        const {selectionCache = {}} = this.collection || {};
        return selectionCache[this.selectionCacheID];
    },

    getPrecheckedOffer() {
        return Odigeo._.find(this.getOffersList(), (offer) => offer.selected && !isMandatory(offer));
    },

    getOfferByPolicy(policy) {
        return Odigeo._.find(this.getOffersList(), (product) => product.policy === policy);
    },

    getSelectedOffer() {
        return this.getOfferByPolicy(this.getSelectedPolicy());
    },

    isInPreRejectedStateAndTryToRejectAgainIt(policyToBeSelected) {
        return this.isInPreRejectedState() && this.isRejected(policyToBeSelected);
    },

    isADeselection(selected, policy) {
        return !Odigeo._.isEmpty(policy) && !this.isRejected(policy) && !selected;
    },

    isMultiOfferRejected(selected, policy) {
        return this.isRejected(policy) || this.isADeselection(selected, policy);
    },

    getMultiOfferSelection(selected, policy) {
        return Odigeo._.reduce(this.getProducts(), function(selection, offer) {
            offer.selected = selected && offer.policy === policy;

            return offer.selected ? offer.policy : selection;
        }, null, this);
    },

    setMultiOfferSelection(selected, policy) {
        const policyToBeSelected = this.getMultiOfferSelection(selected, policy);

        return Odigeo._.isEmpty(policyToBeSelected) && this.isMultiOfferRejected(selected, policy)
            ? REJECTED_POLICY
            : policyToBeSelected;
    },

    getSingleOfferSelection(selected, policy) {
        const policyToBeSelected = selected ? this.getPolicyFromSimpleOffer() : null;

        return this.isRejected(policy)
            ? REJECTED_POLICY
            : policyToBeSelected;
    },

    updateSelection(policyToBeSelected) {
        this.set({
            selected: !Odigeo._.isEmpty(policyToBeSelected) && !this.isRejected(policyToBeSelected),
            selectedPolicy: policyToBeSelected,
        });
    },

    updateIfSelected(policyToBeSelected) {
        if (!this.isInPreRejectedStateAndTryToRejectAgainIt(policyToBeSelected)) {
            const {selectionCache = {}} = this.collection || {};
            selectionCache[this.selectionCacheID] = policyToBeSelected;
            this.updateSelection(policyToBeSelected);
        }
    },

    getPolicyToBeSelected(selected, policy) {
        return this.isMultiOffer()
            ? this.setMultiOfferSelection(selected, policy)
            : this.getSingleOfferSelection(selected, policy);
    },

    setIfSelected(selected, policy) {
        this.updateIfSelected(this.getPolicyToBeSelected(selected, policy));
    },

    isSelectionChanged() {
        return this.hasChanged('selectedPolicy') || this.hasChanged('selected');
    },

    isMultiOffer() {
        return this.get('isMultiOffer');
    },

    getProducts() {
        return this.isMultiOffer() ? this.get('products') : [];
    },

    getProductId(policy) {
        const offer = this.getOfferByPolicy(policy) || {};

        return offer.id;
    },

    getPolicies() {
        return this.getProducts().map((product) => product.policy);
    },

    registerOffersForTracking() {
        Odigeo._.each(this.getOffersList(),
            (product) => this.registerPolicyForTracking(Odigeo._.get(product, 'policy')),
            this);
    },

    registerPolicyForTracking(policy) {
        this.collection.widget.tracking.registerOffer(policy);
    },

    hasMandatoryProductInMultiOffer() {
        return this.isMultiOffer() && Odigeo._.some(this.getProducts(), isMandatory, false);
    },

    getTrackingSelectionData(offer) {
        return {
            id: Odigeo._.get(offer, 'policy'),
            pbdType: Odigeo._.get(offer, 'pbdType'),
            selected: Odigeo._.get(offer, 'selected'),
        };
    },

    notifySelectionChange(isSelected, policy) {
        const offer = this.getOfferByPolicy(policy);
        const {widget = {}} = this.collection || {};

        if (!Odigeo._.isEmpty(offer)) {
            Odigeo.trigger(widget.name + ':selectionChanged', this.getTrackingSelectionData(offer));
        }
    },

    getValidationFailed() {
        return this.get('validationFailed');
    },

    isModelAlreadyValidated() {
        return !Odigeo._.isUndefined(this.getValidationFailed());
    },

    hasValidationFailed() {
        return !this.isModelAlreadyValidated() ? this.hasToDisplayMandatorySelectionError() : false;
    },

    validateProductSelection() {
        const validationFailed = this.hasValidationFailed();
        this.setValidationFailed(validationFailed);
        return validationFailed;
    },

    isContinuanceValidationFailed() {
        return !!this.getValidationFailed();
    },

    hasModal() {
        return !Odigeo._.isEmpty(Odigeo._.find(this.getOffersList(), isModalEnabled));
    },

    hasModalExclusion(offer) {
        return Odigeo._.get(offer, 'flags.showModalExclusions', false);
    },

    hasModalBenefits(offer) {
        return Odigeo._.get(offer, 'flags.showModalBenefits', false);
    },

    hasDualContract(offer) {
        return Odigeo._.get(offer, 'flags.dualContract', false);
    },

    hasIpid(offer) {
        return Odigeo._.get(offer, 'flags.ipid', false);
    },

    isFree(offer) {
        return Odigeo._.get(offer, 'flags.free', false) && Odigeo._.get(offer, 'prices.priceToDisplay') === 0;
    },

    isFirstOffer(offer) {
        return (
            !Odigeo._.isEmpty(this.collection) &&
            Odigeo._.size(Odigeo._.filter(Odigeo._.first(this.collection.models), {id: Odigeo._.get(offer, 'id')})) > 0
        );
    },

    canAddOfferFromModal(offer) {
        return Odigeo._.get(offer, 'flags.addFromModal', false);
    },

    isDisplayable(offer) {
        return Odigeo._.get(offer, 'flags.displayable', true);
    },

    getOffersList() {
        return this.isMultiOffer() ? this.getProducts() : [this.getAll()];
    },

    getFilteredOffersList() {
        return this.getOffersList().filter(({policy}) => !isProductFiltered(policy));
    },

    rejectProductSelection() {
        this.selectProduct({selected: true, policy: this.getRejectedPolicy()});
        this.setValidationFailed(false);
    },

    isSingleOfferNotSelected() {
        return !this.isMultiOffer() && !this.isSelected();
    },

    rejectProductSelectionIfIsNotSelected() {
        if (this.isSingleOfferNotSelected()) {
            this.rejectProductSelection();
        }
    },

    isPrecheckedMarket() {
        return this.get('isPrecheckedMarket');
    },

    setValidationFailed(failed) {
        this.set('validationFailed', failed);
    },

    getLastPolicyInteractedWith() {
        return this.lastPolicyInteractedWith;
    },

    setLastPolicyInteractedWith(policy) {
        this.lastPolicyInteractedWith = policy;
    },

    isMultiOfferWithOnlyMandatory() {
        return this.isMultiOffer() && Odigeo._.every(this.getProducts(), (product) => {
            return product.flags.mandatory || !product.flags.displayable;
        });
    },

    isAncillariesChangeAttachmentButtonType() {
        return Odigeo.AB.isAncillariesChangeAttachmentButtonType;
    },

    isAncillariesChangeAttachmentButtonTypeAdditions() {
        return Odigeo.AB.isAncillariesChangeAttachmentButtonTypeAdditions;
    },
});
